import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom'; // Import Link from React Router
import Contact from '../components/contact'; 
import Navbar from '../components/navbar';// Import the Contact component

const Home = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      className="font-sans"
    >
  
      {/* Hero Section */}
      <div className="relative h-screen flex items-center justify-center">
        {/* Background Video */}
        <video
          className="absolute inset-0 w-full h-full object-cover"
          src="\videos\1.mp4"
          autoPlay
          loop
          muted
        ></video>

        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-40"></div>

        {/* Content */}
        <div className="relative z-10 text-center">
          <motion.h1
            className="text-6xl font-extrabold text-white mb-4"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1 }}
          >
            Welcome to  Corehire Solutions
          </motion.h1>
          <motion.p
            className="text-xl font-medium text-gray-200"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2 }}
          >
            Bridging the gap between job seekers and employers with brighter opportunities!
          </motion.p>
        </div>
      </div>

      {/* About Section */}
      <motion.section
        className="py-16 bg-gradient-to-r from-pink-100 via-yellow-100 to-purple-100 text-gray-800"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-6 text-purple-700">About  Corehire Solutions</h2>
          <motion.p
            className="text-lg mb-6"
            initial={{ x: -50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 1 }}
          >
             Corehire Solutions is a trusted name in placement consultancy situated in Gurgaon,
            dedicated to bridging the gap between job seekers and employers. Our mission is to empower
            individuals and businesses with the right opportunities and talent to thrive in today’s
            competitive landscape.
          </motion.p>
          <motion.p
            className="text-lg"
            initial={{ x: 50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 1.2 }}
          >
            We specialize in providing personalized career guidance, recruitment solutions, and
            professional development services. Whether you are a candidate seeking your dream job or
            an organization looking for the perfect fit,  Corehire Solutions ensures seamless
            connections through a thorough understanding of your needs.
          </motion.p>
        </div>
      </motion.section>

      {/* Goals Section */}
      <motion.section
        className="py-16 bg-gradient-to-r from-blue-100 via-pink-100 to-yellow-100 text-gray-800"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-6 text-blue-800">Our Goal</h2>
          <motion.ul
            className="space-y-4 text-lg"
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            <li>🌟 Placement Assistance: Connecting job seekers with reputable companies across diverse industries.</li>
            <li>🌟 Career Counseling: Helping candidates identify their strengths and career goals.</li>
            <li>🌟 Recruitment Solutions: Assisting businesses in finding the right talent efficiently.</li>
          </motion.ul>
        </div>
      </motion.section>

      {/* Services Section */}
      <motion.section
        className="py-16 bg-white text-gray-900"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-6 text-pink-800">OUR EXPERTISE</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { title: "Process Outsourcing", description: "Comprehensive BPO services tailored to enhance efficiency and reduce operational costs." },
              { title: "Financial Services", description: "Expertise in NBFC and BFSI sectors, providing solutions for risk management and compliance." },
              { title: "Travel Solutions", description: "Innovative IT services for the travel industry, including booking systems and customer support." },
              { title: "IT Consulting", description: "End-to-end IT solutions for businesses to achieve digital transformation and scalability." },
              { title: "Customer Support Services", description: "24/7 support solutions to improve customer satisfaction and retention." },
              { title: "Data Management", description: "Streamlined data processing and analytics to support informed decision-making." },
              { title: "Recruitment for Specialized Roles", description: "Targeted hiring solutions for niche roles in BPO, NBFC, BFSI, and IT sectors." },
            ].map((service, index) => (
              <motion.div
                key={index}
                className="bg-gradient-to-r from-yellow-200 to-pink-300 p-6 shadow-lg rounded-lg cursor-pointer"
                initial={{ scale: 0.8, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
              >
                <Link to="/contact" className="block">
                  <h3 className="text-xl font-bold mb-2">{service.title}</h3>
                  <p>{service.description}</p>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>

      {/* Reviews Section */}
      <motion.section
        className="py-16 bg-gradient-to-r from-yellow-100 via-blue-100 to-purple-100 text-gray-900"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-6 text-blue-800">WHAT OUR CLIENTS SAY</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[
              { name: "Rajesh Kumar", review: "The team was highly professional and delivered exceptional service. Our project was completed on time and exceeded expectations." },
              { name: "Anita Desai", review: "Fantastic experience working with this company. They understood our requirements and provided tailored solutions that helped our business grow." },
              { name: "Vikram Singh", review: "Reliable and efficient services. The customer support was prompt and helpful throughout the process." },
              { name: "Priya Sharma", review: "Their expertise in the field is unmatched. We saw a significant improvement in our operations after implementing their recommendations." }
            ].map((client, index) => (
              <motion.div
                key={index}
                className="bg-white p-6 shadow-md rounded-lg"
                initial={{ y: 50, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.8, delay: index * 0.2 }}
              >
                <p className="italic">"{client.review}"</p>
                <p className="mt-4 text-sm font-bold">- {client.name}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>

      {/* Contact Us Section - Replace with the Contact Component */}
      <Contact />
    </motion.div>
  );
};

export default Home;
